export default "__VITE_ASSET__ByYyRL1P__"